import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import { useEffect, useLayoutEffect, useState } from 'react';
import debounce from 'lodash/debounce';
var useMobile = function useMobile(breakpoint) {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isMobile = _useState2[0],
    setIsMobile = _useState2[1];
  useEffect(function () {
    if (typeof window !== 'undefined') {
      if (window.innerWidth < breakpoint) {
        setIsMobile(true);
      }
    }
  }, []);
  useLayoutEffect(function () {
    if (typeof window !== 'undefined') {
      var updateSize = function updateSize() {
        setIsMobile(window.innerWidth < breakpoint);
      };
      window.addEventListener('resize', debounce(updateSize, 250));
      return function () {
        return window.removeEventListener('resize', updateSize);
      };
    }
  }, []);
  return isMobile;
};
export default useMobile;